<template>
      <!-- 顶部按钮栏 -->
      <div class="top-actions">
        <div class="left-actions">
          <a-button type="primary" @click="handleClose">返回</a-button>
        </div> 
      </div> 
  
   <div id="app">
      <div class="sidebar">
        <Card />
        <List />
      </div>
      <div class="main">
        <Message />
        <Text />
      </div>
      <div class="sidebarRight">
        <right />
      </div>
    </div>

  </template>
  

  <script lang="ts" setup>
  import { useStore } from 'vuex';
  import { onMounted } from 'vue';
  import Card from './card.vue';
  import List from './list.vue';
  import Text from './text.vue';
  import Message from './message.vue';
  import right from './right.vue';

  const store = useStore();
  
  const emit = defineEmits<{
  (e: "update:visible", visible: boolean): void;
}>();

  onMounted(() => {
    store.dispatch('initData');
  });


  // 处理关闭
const handleClose = () => {
  emit("update:visible", false);
};

  </script>


  
  <style lang="less" scoped>
  #app {
    margin: 20px auto;
    width: 1000px;
    height: 600px;
    display: flex;
    border-radius: 3px;
  
    .sidebar,
    .sidebarRight,
    .main {
      height: 100%;
      width: 560px;
    }


    .top-actions {
      padding: 12px;
      background: #fff;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .left-actions {
      display: flex;
      gap: 8px;
    }

    .sidebar {
      float: left;
      width: 200px;
      color: #f4f4f4;
      background-color: #2e3238;
    }

    .sidebarRight {
      height: 100%;
      width: 200px;
    }
  
    .main {
      position: relative;
      overflow: hidden;
      background-color: #eee;
    }

    .header-buttons {
      display: flex;
      gap: 8px;
    }
  
    .text {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
    }
  
    .message {
      height: calc(100% - 160px);
      width: 100%;
    }
  }
  </style>